[
  {
    "id": "GET-M7-L203-001",
    "module": "Getalbegrip",
    "difficulty": 203,
    "question": "De verhouding rood : blauw is 1 : 4. Er zijn 20 knikkers in totaal. Hoeveel zijn er rood?",
    "options": [
      "4",
      "5",
      "1",
      "16"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "verhoudingen",
    "subSkill": "verhoudingen",
    "familyId": "GET-VERHOUDING",
    "explanation": "1 + 4 = 5 delen in totaal. 20 : 5 = 4 per deel. Rood is 1 deel, dus 4 knikkers.",
    "distractorExplanations": {
      "1": "Je hebt gedeeld door 4 in plaats van 5.",
      "2": "Dat is het aantal delen.",
      "3": "Dat zijn de blauwe knikkers."
    }
  },
  {
    "id": "GET-M7-L203-002",
    "module": "Getalbegrip",
    "difficulty": 203,
    "question": "Wat is 50% van 640?",
    "options": [
      "320",
      "300",
      "340",
      "160"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "procenten",
    "subSkill": "procenten",
    "familyId": "GET-PROC-HELFT",
    "explanation": "50% is de helft. De helft van 600 is 300, de helft van 40 is 20. Samen 320.",
    "distractorExplanations": {
      "1": "Je bent de 40 vergeten te halveren.",
      "2": "Je hebt een rekenfout gemaakt.",
      "3": "Dat is 25% (een kwart)."
    }
  },
  {
    "id": "GET-M7-L203-003",
    "module": "Getalbegrip",
    "difficulty": 203,
    "question": "Het vriest 3 graden. Het wordt 5 graden warmer. Hoe warm is het nu?",
    "options": [
      "2 graden",
      "-2 graden",
      "8 graden",
      "-8 graden"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "getallenleer",
    "subSkill": "negatieve_getallen",
    "familyId": "GET-NEGATIEF",
    "explanation": "Het is -3 graden. Je telt er 5 bij op. -3 + 3 = 0. Dan nog 2 erbij. Het is 2 graden.",
    "distractorExplanations": {
      "1": "Je hebt de verkeerde kant op gerekend.",
      "2": "Je hebt 3 en 5 opgeteld zonder naar de min te kijken.",
      "3": "Je hebt het nog kouder gemaakt."
    }
  },
  {
    "id": "GET-M7-L203-004",
    "module": "Getalbegrip",
    "difficulty": 203,
    "question": "Schrijf als kommagetal: $\\frac{3}{10}$",
    "options": [
      "0,3",
      "0,03",
      "3,0",
      "0,33"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "breuken",
    "subSkill": "breuken_komma",
    "familyId": "GET-KOMMA-BREUK",
    "explanation": "Drie tiende schrijf je als 0,3.",
    "distractorExplanations": {
      "1": "Dat is drie honderdste.",
      "2": "Dat is drie hele.",
      "3": "Dat is ongeveer een derde."
    }
  },
  {
    "id": "GET-M7-L203-005",
    "module": "Getalbegrip",
    "difficulty": 203,
    "question": "Reken uit: 1.000.000 - 1",
    "options": [
      "999.999",
      "999.990",
      "900.000",
      "999.000"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "getallenleer",
    "subSkill": "grote_getallen",
    "familyId": "GET-GROTE-GETALLEN",
    "explanation": "Eén minder dan een miljoen is negenhonderdnegenennegentigduizend negenhonderdnegenennegentig.",
    "distractorExplanations": {
      "1": "Je hebt er 10 afgehaald.",
      "2": "Je hebt er 100.000 afgehaald.",
      "3": "Je hebt er 1.000 afgehaald."
    }
  }
]